import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";

import { Post } from "./post.component";
import { usePostStore } from "@/common/store/post.store";
import {
  ANNOUNCEMENTS_CHANNEL_ID,
  CHANNEL_CONST
} from "@/common/utils/constant";
import { ProfileSkeletonLoader } from "../skeleton_loader";

import styles from "./post.css";

SinglePost.propTypes = {
  roles: PropTypes.array,
  focusedNotification: PropTypes.object,
  teamId: PropTypes.string
};

export function SinglePost(props) {
  const history = useHistory();
  let urlSplit = history.location.pathname.split("/");
  let [teamId, mediumId, postId] = [urlSplit[2], urlSplit[4], urlSplit[6]];

  const postContent = usePostStore(
    // eslint-disable-next-line kf/hook-func-name, react-hooks/exhaustive-deps
    useCallback((state) => state.postData[postId], postId)
  );

  const [loading, setLoading] = useState(false);
  const [postDataLoaded, setPostDataLoaded] = useState(false);
  const [callComments, setCallComments] = useState(false);
  const postNotification = history.location.state;

  useEffect(
    function fetchPost() {
      if (postContent) {
        setPostDataLoaded(true);
        return;
      }
      setLoading(true);
      setCallComments(true);
      let [getPostDataResponse] = usePostStore
        .getState()
        .getPostByIdData(teamId, mediumId, postId);
      getPostDataResponse
        .then(() => {
          setLoading(false);
          setPostDataLoaded(true);
        })
        .catch((err) => {
          setLoading(false);
          console.info(err);
        });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [postId]
  );

  return (
    <div className={styles.postListWrapper}>
      {!loading && postDataLoaded ? (
        <Post
          teamId={teamId}
          roles={props.roles}
          medium={CHANNEL_CONST.CHANNEL}
          mediumId={mediumId}
          postId={postId}
          postNotification={postNotification}
          focusedNotification={props.focusedNotification}
          isAnnouncement={mediumId === ANNOUNCEMENTS_CHANNEL_ID}
          showMediumOption={true}
          shouldCallDefaultComments={callComments}
        />
      ) : (
        <div style={{ width: "62rem", margin: "1rem auto" }}>
          <ProfileSkeletonLoader />
          <div
            className="skeleton-loader"
            style={{ width: "90%", height: "20rem", margin: "1rem auto" }}
          />
          <div
            className="skeleton-loader"
            style={{ width: "90%", height: "8rem", margin: "1rem auto" }}
          />
        </div>
      )}
    </div>
  );
}
